
namespace Gamification.Gamification {

    export interface UtentiProdottiEsperienzeTaskListGridOptions {
        IdUtenteProdottoEsperienza: number,
        IdProdottoEsperienzaNome: string,
        DataOraInizio: string
    }

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeTaskListGrid extends Serenity.EntityGrid<UtentiProdottiEsperienzeTaskRow, any> {
        protected getColumnsKey() { return UtentiProdottiEsperienzeTaskColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiEsperienzeTaskDialog; }
        protected getIdProperty() { return UtentiProdottiEsperienzeTaskRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeTaskRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeTaskService.baseUrl; }

        constructor(container: JQuery, options: UtentiProdottiEsperienzeTaskListGridOptions) {
            super(container, options);

            var theData = new Date(options.DataOraInizio);
            this.setTitle("Task dell'esperienza " + options.IdProdottoEsperienzaNome + " del " + theData.toLocaleDateString() + " ore " + theData.toLocaleTimeString());
        }

        protected createQuickSearchInput() { }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            return buttons;
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            request.Criteria = Serenity.Criteria.and([[Gamification.UtentiProdottiEsperienzeTaskRow.Fields.IdUtenteProdottoEsperienza], '=', this.options.IdUtenteProdottoEsperienza], request.Criteria);

            return true;
        }
    }
}